// The class defined here allows Javascript to obtain values from the various
// resource files such as HelpForModuleResources.
(function($) {
	
	// Define the ResourceHelper class
	var ResourceHelper = function(resourceName, browserLanguage) {
		
		// Save resource name for later. We will not read
		// the file until request
		this.resourceName = resourceName;
		this.browserLanguage = browserLanguage;
		this.properties = null;
		
		// Function to request a value from the file
		this.getValue = function(key) {
			
			// If we have not requested the file yet, go
			// get it..
			this.checkProperties();
			if (this.properties !== null)
				return this.properties[key.trim()];
			else
				return null;
		};
		
		// Slow - but does partial key matches
		this.getValuePartialMatch = function(key) {
			this.checkProperties();
			if (this.properties !== null) {
				key = key.trim();
				for (var propt in this.properties) {
					if (key.indexOf(propt) === 0) {
						return this.properties[propt];
					}
				}
			}
			
			return null;
		};
		
		this.containsKey = function(key) {
			this.checkProperties();
			if (this.properties !== null)
				if (this.properties[key.trim()])
					return true;
				else
					return false;
			else
				return false;
		};
		
		this.checkProperties = function() {
			if (this.properties === null) {
				var me = this;
				$.ajax({
					type    : 'GET',
					url     : 'utils/getProperties',
					data    : { file: this.resourceName },
					async   : false,
					dataType: 'json',
					success : function(resp) {						
						if (!!me.browserLanguage) {
							Object.keys(resp).forEach(function(key){
								resp[key] = `${me.browserLanguage}/${resp[key]}`;
							});
						}
						
						me.properties = resp;
					}
				});
			}
		};
	};

	// Expose ResourceHelper to the world
	window.ResourceHelper = ResourceHelper;
}) (jQuery);